// AuthContext.js
import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(
    sessionStorage.getItem("authToken") || null
  );
  const [email, setEmail] = useState(
    sessionStorage.getItem("userEmail") || null
  );

  const setAuthToken = (newToken) => {
    setToken(newToken);
    sessionStorage.setItem("authToken", newToken);
  };
  const setUserEmail = (newEmail) => {
    setEmail(newEmail);
    sessionStorage.setItem("userEmail", newEmail);
  };

  // const clearAuthData = () => {
  //   setToken(null);
  //   setUserEmail(null);
  //   sessionStorage.removeItem('authToken');
  //   sessionStorage.removeItem('userEmail');
  // };
  // useEffect(() => {
  //   // You can perform additional initialization or checks here

  //   // Cleanup function when the component unmounts
  //   return () => {
  //     clearAuthData();
  //   };
  // }, []);

  return (
    <AuthContext.Provider
      value={{
        token,
        setAuthToken,
        email,
        setUserEmail,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
